module.exports = __webpack_public_path__ + "static/136212744-6b144efc1a83e1404073e71907d6d07d.jpg";